export default function Highlight({ subtitle, topTitle, text, reverse }) {
  return (
    <section>
      <div className="my-4 flex justify-center font-['Inter'] w-full" tabIndex={0}>
        <div
          className={`${
            reverse
              ? "w-full xl:max-w-7xl lg:max-w-4xl md:max-w-3xl flex flex-col items-center lgjustify-between lg:flex-row-reverse "
              : "w-full xl:max-w-7xl lg:max-w-4xl md:max-w-3xl flex flex-col items-center lg:justify-between  lg:flex-row"
          }`}
        >
          <div className="lg:w-1/2 px-16 pt-16 lg:p-16 w-full">
            <p className="text-orange-400 font-bold mb-1 lg:mt-0 mt-4">
              {subtitle}
            </p>
            <h3 className="medium-title">
              {topTitle}
            </h3>
          </div>
          <div className="lg:w-1/2 px-16 py-6 lg:p-16">
            <p className="body-text descp" dangerouslySetInnerHTML={{__html: text}}></p>
          </div>
        </div>
      </div>
    </section>
  );
}
